import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Row, Space, Button } from "@masterteam/mt-design-react";

import Actions from "./Actions";
import Modal from "../Modal";
import RequestActionModal from "../RequestActionModal";

import "./style.scss";

const initialActionModal = {
  isOpen: false,
  isApprove: false,
  isReturn: false,
  data: null
};

const FormHeader = ({
  title,
  cancelRoute,
  customButton,
  canApprove,
  handleSaveAsDraft,
  data,
  getData,
  isReadOnly
}) => {
  const [actionModal, setActionModal] = useState(initialActionModal);

  return (
    <>
      <Row className="header" align="center" justify="between">
        <FormattedMessage id={title} />

        {isReadOnly && canApprove ? (
          <Space align="center" size="medium">
            <Button
              variant="success"
              onClick={(e) => {
                e.stopPropagation();
                setActionModal({
                  isOpen: true,
                  isApprove: true,
                  data
                });
              }}
            >
              <FormattedMessage id="common.approve" />
            </Button>
            {/* <Button
              variant="dark"
              onClick={(e) => {
                e.stopPropagation();
                setActionModal({
                  isOpen: true,
                  isApprove: false,
                  isReturn: true,
                  data
                });
              }}
            >
              <FormattedMessage id="common.return" />
            </Button> */}
            <Button
              variant="error"
              onClick={(e) => {
                e.stopPropagation();
                setActionModal({
                  isOpen: true,
                  isApprove: false,
                  data
                });
              }}
            >
              <FormattedMessage id="common.reject" />
            </Button>
          </Space>
        ) : !isReadOnly ? (
          <Actions
            cancelRoute={cancelRoute}
            customButton={customButton}
            handleSaveAsDraft={handleSaveAsDraft}
          />
        ) : null}
      </Row>
      {actionModal.isOpen ? (
        <Modal isOpen={actionModal.isOpen}>
          <RequestActionModal
            measureItem={actionModal?.data}
            callback={() => getData()}
            closeModal={() => setActionModal(initialActionModal)}
            isApprove={actionModal?.isApprove}
            isReturn={actionModal?.isReturn}
          />
        </Modal>
      ) : null}
    </>
  );
};

export default FormHeader;
